import styled from 'styled-components'

const QuestionListItemUi = styled.div`
  margin-bottom: 15px;
  display: flex;
  align-items: center;
`

export default QuestionListItemUi
